/*
 * @Author       : Lobin
 * @Date         : 2020-10-14 14:56:38
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2021-07-29 19:05:31
 */
const audioData = require("../assets/audio.json");
let audio;
async function dataURL2Audio(base64, type) {
  const base64Str = base64.replace("data:audio/x-wav;base64,", "");
  const audioName = type + ".wav";
  return new Promise((resolve, reject) => {
    plus.io.requestFileSystem(plus.io.PRIVATE_DOC, function(fs) {
      fs.root.getFile(audioName, { create: true }, function(entry) {
        // 获得平台绝对路径
        var fullPath = entry.fullPath;
        // 读取音频
        var Base64 = plus.android.importClass("android.util.Base64");
        var FileOutputStream = plus.android.importClass(
          "java.io.FileOutputStream"
        );
        try {
          var out = new FileOutputStream(fullPath);
          var bytes = Base64.decode(base64Str, Base64.DEFAULT);
          out.write(bytes);
          out.close();
          // 回调
          resolve(entry.toURL());
        } catch (e) {
          console.log(e.message);
          reject(e);
        }
      });
    });
  });
}
export const awaitTo = promise => {
  return promise
    .then(res => {
      return [null, res];
    })
    .catch(err => {
      return [err, null];
    });
};
export const playVoice = async type => {
  console.log(type);
  // const src = audioData[type];
  // if (window.plus) {
  //   const localUrl = await dataURL2Audio(src, type);
  //   audio = plus.audio.createPlayer(localUrl);
  // } else {
  //   audio = new Audio();
  //   audio.src = src;
  // }
  // audio.play();
};
